import { Module } from 'i18next';
import { indefiniteArticle } from './indefiniteArticle';

const formatters = {
  indefiniteArticle,
};

export const customFormatters: Module & { init } = {
  type: '3rdParty',
  init: instance => {
    if (instance.services.formatter) {
      for (const [formatterName, formatterFunction] of Object.entries(formatters)) {
        instance.services.formatter.add(formatterName, formatterFunction);
      }
    }
  },
};
